<template>
    <div class="just-padding" v-if="node.type === 'dir'">
        <div class="list-group list-group-root well">
            <div class="list-group-item bg-hover" @click="toggleNode" role='button'
                 :style="{'padding-left': paddingByLevel + 'px'}">
                <i class="bi" :class="showChildren ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                <i class="bi bi-folder tree-pl-5"></i>
                <router-link class="text-dark tree-pl-5" :to="{ path: '/structures', query: { dir: node.fullName } }" @click.stop>{{ node.name }}</router-link>
                <span class="badge bg-light text-dark float-end">{{ node.count }}</span>
            </div>
        </div>
        <div class="list-group" v-show="showChildren" v-if="node.children && node.children.length > 0">
            <div v-for="(item, index) in node.children" :key="index">
                <TreeNode :node="item" :level="level + 1"></TreeNode>
            </div>
        </div>
    </div>

    <div class="just-padding" v-else>
        <div class="list-group">
            <a href="#" class="list-group-item bg-hover"
               :style="{'padding-left': paddingByLevel + 5 + 'px'}">
                <i class="bi bi-search tree-pl-5"></i>
                <router-link class="text-dark tree-pl-5" :to="{ path: '/structures', query: { search: node.name } }">{{ node.name }}</router-link>
            </a>
        </div>
    </div>
</template>
<script>
export default {
    name: 'TreeNode',
    props: {
        node: {
            type: Object,
            default: () => ({})
        },
        level: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            showChildren: false
        }
    },
    methods: {
        toggleNode() {
            this.showChildren = !this.showChildren;
        }
    },
    computed: {
        paddingByLevel() {
            return 5 + this.level * 15;
        }
    },
}
</script>
